import {
  AdjustTermKey,
  AdjustTerms,
  PairedSalesAnalysisFeature,
  ToolkitProperty,
} from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

import { ReconciliationForm } from './ReconciliationForm.js';
import { ReconciliationTable } from './components/ReconciliationTable.js';
import { isPairedSalesCustomAnalysisFeature } from './utils/isPairedSalesCustomAnalysisFeature.js';

export const Reconcile = ({
  term,
  activePairIndex,
  onRowSelect,
  onDeletePair,
}: {
  term: PairedSalesAnalysisFeature;
  activePairIndex: number;
  onRowSelect: (index: number) => void;
  onDeletePair: (p1: ToolkitProperty, p2: ToolkitProperty) => void;
}) => {
  const label = isPairedSalesCustomAnalysisFeature(term)
    ? term.name
    : (AdjustTerms[term as AdjustTermKey].label ?? term);
  return (
    <Flex
      flexDirection="column"
      height="100%"
      width="100%"
      overflow="auto"
      padding={6}
      gap="12px"
      boxShadow="-2px 0px 4px 0px #0000000F"
    >
      <Typography variant="h1">{`${label ?? 'Unknown Feature'}`} Analysis</Typography>

      <ReconciliationTable
        feature={term}
        activePairIndex={activePairIndex}
        onRowSelect={onRowSelect}
        onDeletePair={onDeletePair}
      />

      <ReconciliationForm />
    </Flex>
  );
};
